import React, { useEffect, useState } from "react";
import Tabs from "../../common/Tabs";
import BasicCalculations from "./basiccalculations";
import GasCalculations from "./gascalculations";
import Motor from "./motor";
import Pump from "./pump";
import Protector from "./protector";
import Cable from "./cable";
import SurfaceEquipment from "./surface-equipment";
import WellSurvey from "./well-survey";
import { useLocation } from "react-router-dom";
import useCollapseFacade from "../../../facade/collapse.Facade";
import "./style.scss";



const CalculationSection: React.FC = () => {
    const [activeTab, setActiveTab] = useState<number>(0);
    const location = useLocation();
    const {
        updateGasHandlersCollapse,
        updateGasChargePumpCollapse,
        updateGasFormulasCollapse,
        updateMotorPerformmanceDataCollapse,
        updateFluidVelocityCheckCollapse,
        updateBasicWIFCollapse,
        updateBasicIPRCollapse,
        updateBasicTDHCollapse,
        updatePumpCollapse,
        updateProtectorCollapse,
        updateOilContractionCollapse,
        updateSurfaceVoltCollapse,
        updateCableCleavoltCollapse,
        updateBaseLineCollapse,
        updateWappertwoCollapse,
        updateWapperHarmonicFilterCollapse,
        updateMotorCalculationsCollapse,
        updateMotorRatingCollapse,
        updateSummaryCollapse
    } = useCollapseFacade();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabName = params.get("tab");
        const hash = location.hash;

        if (tabName) {
            const tabIndex = tabs.findIndex(tab =>
                tab.label.toLowerCase().replace(/\s+/g, "-") === tabName.toLowerCase()
            );

            if (tabIndex !== -1) {
                setActiveTab(tabIndex);

                if (hash === "#FluidVel") {
                    updateFluidVelocityCheckCollapse(false);
                }
                else if (hash === "#MotorPerformanceCal") {
                    updateMotorPerformmanceDataCollapse(false);
                }
                else if (hash === "#MotorCal") {
                    updateMotorCalculationsCollapse(false);
                }
                else if (hash === "#MotorDeratingCal") {
                    updateMotorRatingCollapse(false);
                }
                else if (hash === "#gas-formulas") {
                    updateGasFormulasCollapse(false);
                }
                else if (hash === "#wapperGasHandlers") {
                    updateGasHandlersCollapse(false);
                }
                else if (hash === "#wapperChargePump") {
                    updateGasChargePumpCollapse(false);
                }
                else if (hash === "#WIF") {
                    updateBasicWIFCollapse(false);
                }
                else if (hash === "#IPR") {
                    updateBasicIPRCollapse(false);
                }
                else if (hash === "#TDH") {
                    updateBasicTDHCollapse(false);
                }
                else if (hash === "#PC") {
                    updatePumpCollapse(false);
                }
                else if (hash === "#Protc") {
                    updateProtectorCollapse(false);
                }
                else if (hash === "#OilContraction") {
                    updateOilContractionCollapse(false);
                }
                else if (hash === "#CableCleavolt") {
                    updateCableCleavoltCollapse(false);
                }
                else if (hash === "#SurfaceVolt") {
                    updateSurfaceVoltCollapse(false);
                }
                else if (hash === "#baseLine") {
                    updateBaseLineCollapse(false);
                }
                else if (hash === "#wappertwo") {
                    updateWappertwoCollapse(false);
                }
                else if (hash === "#wapperHarmonicFilter") {
                    updateWapperHarmonicFilterCollapse(false);
                }
                else if (hash === "#espAssembly") {
                    updateSummaryCollapse(false);
                }

                setTimeout(() => {
                    if (hash) {
                        const element = document.getElementById(hash.replace("#", ""));
                        if (element) {
                            const offset = 350;
                            const y = element.getBoundingClientRect().top + window.pageYOffset - offset;

                            window.scrollTo({ top: y, behavior: "smooth" });
                        }
                    }
                }, 500);
            }
        } else if (location.hash) {
            setTimeout(() => {
                const element = document.getElementById(location.hash.replace("#", ""));
                if (element) {
                    const offset = 350;
                    const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            }, 500);
        }
    }, [location]);

    const handleTabChange = (tab: number): void => {
        setActiveTab(tab);
    };

    const tabs = [
        {
            label: "Gas calculations",
            content: <GasCalculations />,
        },
        {
            label: "Basic calculations",
            content: <BasicCalculations />,
        },
        {
            label: "Pump",
            content: <Pump />,
        },
        {
            label: "Motor",
            content: <Motor />,
        },
        {
            label: "Protector",
            content: <Protector />,
        },
        {
            label: "Cable",
            content: <Cable />,
        },
        {
            label: "Surface equipment",
            content: <SurfaceEquipment />,
        },
        {
            label: "Well survey",
            content: <WellSurvey />,
        },
    ];

    return (
        <div className="calculations">
            <Tabs
                tabs={tabs}
                activeTab={activeTab}
                onChange={handleTabChange}
                className=""
            />
        </div>
    );
};

export default CalculationSection;

